<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import TableLoading from "@/components/ipos/table-loading";
import {reportService} from "@/services/authservice/report";
import UtilsMixin from "@/mixins/utils";
import Multiselect from "vue-multiselect";
import {brandService} from "@/services/authservice/brand";
import {Workbook} from "exceljs";
import * as fs from "file-saver";
import {base} from "@/services/base";
import {itemService} from "@/services/authservice/item";
import {inventoryService} from "@/services/authservice/inventory";
import ComponentCurrencyInput from "@/components/currency";
import moment from "moment";

export default {
  page: {
    title: "Tạo phiếu kiểm kho",
    meta: [{name: "description", content: appConfig.description}],
  },
  mixins: [UtilsMixin],
  components: {ComponentCurrencyInput, Layout, PageHeader, DatePicker, TableLoading, Multiselect},
  data() {
    return {
      title: "Tạo phiếu kiểm kho",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Tạo phiếu kiểm kho",
          active: true,
        },
      ],
      listProductAll: [],
      listProduct: [],
      listBrand: [],
      listResult: [],
      selectedItem: [],
      formData: {
        stTime: "",
        brand: "",
        note: "",
      },
      keyword: "",
      isBusy: true,
      isBtnLoading: false,
      submitted: false,
      isLoadingSearch: false,
      me: {},
      fileImport: null,
      step: 1,
      tabCheck: 1,
      listError: [],
      listSuccess: [],
      isLoadingCheck: false,
      loadUnit: false,
      listUnit: [],
      isChangeBrandTime: false
    };
  },

  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getInitData();
  },

  methods: {
    async getInitData() {
      this.isBusy = true;
      // get list brand
      const resBrand = await brandService.getList();
      if (resBrand.data.error) {
        this.listBrand = [];
      } else {
        this.listBrand = resBrand.data.data;
      }
      // get list item
      this.formData.stTime = new Date();
      this.isBusy = false;
    },

    async getItem(){
      this.listProductAll = []
      this.listProduct = []
      const resItem = await reportService.getReportStockSummary({
        trademark_uid: this.formData.brand&&this.formData.brand.id || undefined,
        warehouse_uid: this.me.warehouse_uid,
        to_timestamp: this.formData.stTime.getTime() || undefined,
      });
      if (resItem.data.error) {
        this.listProductAll = [];
        this.listProduct = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: resItem.data.error.message,
        });
      } else {
        this.listProductAll = resItem.data.data.map((e)=>{
          return {
            ...e,
            id: e.item_uid
          }
        });
        this.listProduct = this.listProductAll.map((e)=>{
          return{
            ...e
          }
        });
      }
    },

    async onChangeBrandAndTime(type, value) {
      if(type === 'time'){
        this.formData.stTime = moment(value).isSame(moment(),'day') ? moment().toDate() : new Date(value.setHours(23, 59, 59, 999))
      }
      this.isChangeBrandTime = true
      this.selectedItem = [];
      this.$nextTick(async () => {
        await this.getItem()
        this.selectedItem = this.listProduct.map(e => {
          return {
            ...e,
            quantity: e.ed_qty,
            check_qty: e.ed_qty,
            note: "",
            unit: {
              id: e.unit_uid,
              unit_id: e.unit_id,
              unit_name: e.unit_name
            }
          }
        });
        this.isChangeBrandTime = false
      })
    },

    async onShowUnit(row) {
      this.loadUnit = true
      this.listUnit = []
      if (row.unit && row.unit.id) {
        const res = await itemService.getListUnitByItem({
          item_uid: row.item_uid,
          unit_uid: row.unit.id
        })
        if (res.data && res.data.data) {
          this.listUnit = res.data.data
        } else {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: res.data && res.data.error && res.data.error.message || 'Error',
          });
        }
      }
      this.loadUnit = false
    },

    async handleChangeUnit(value, row) {
      row.unit = value
      row.unit_uid = value.id
      row.unit_id = value.unit_id
      row.unit_name = value.unit_name
      const res = await inventoryService.reportInventoryChangeUnit({
        item_uid: row.item_uid,
        unit_uid: value.id,
        warehouse_uid: this.me.warehouse_uid,
        to_date: this.formData.stTime.getTime()
      })
      if(res.data && res.data.data){
        row.quantity = res.data.data.inventory_qty
      }else{
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data && res.data.error && res.data.error.message || 'Error',
        });
      }
    },

    onChangeNote(value, id) {
      this.selectedItem = this.selectedItem.map(obj => {
            if (obj.id === id) {
              return {...obj, note: value ? value : ""};
            }
            return obj
          }
      );
    },

    removeItem(id) {
      if (id) {
        this.selectedItem = this.selectedItem.filter(e => e.id !== id);
      } else {
        this.selectedItem = [];
      }
    },

    onSearchItem(key) {
      this.keyword = key;
      const refKey = this.convertVnTextToEnglish(key);
      if (key !== null && key !== '' && key !== undefined) {
        let cloneArr = JSON.parse(JSON.stringify(this.listProduct));
        this.listResult = cloneArr.filter(
            e => this.convertVnTextToEnglish(e.item_name).indexOf(refKey.toUpperCase()) >= 0 || this.convertVnTextToEnglish(e.sku).indexOf(refKey.toUpperCase()) >= 0);
      } else {
        this.listResult = [];
      }
    },

    onSelectResult(item) {
      this.listResult = [];
      this.keyword = "";
      const find = this.selectedItem.filter(e => e.id === item.id);
      if (find.length === 0) {
        const obj = {...item,
          quantity: item.ed_qty,
          check_qty: item.ed_qty,
          unit: {
            id: item.unit_uid,
            unit_id: item.unit_id,
            unit_name: item.unit_name
          },
          note: ""
        };
        this.selectedItem.push(obj);
      }
    },

    renderAction(item) {
      if (item.check_qty === item.quantity) {
        return "";
      } else {
        if (item.check_qty > item.quantity) {
          return "Nhập điều chỉnh";
        } else {
          return "Xuất điều chỉnh";
        }
      }
    },

    handleImport() {
      if (this.formData.brand) {
        this.$bvModal.show("md-import");
      } else {
        this.$notify({
          group: "app",
          type: "error",
          text: "Vui lòng chọn nhãn hàng trước khi import",
        });
      }
    },

    handleCloseImport(){
      this.$bvModal.hide("md-import");
      this.onChangeTab(1)
      this.listError = []
      this.listSuccess = []
    },

    onChangeTab(id) {
      if (this.fileImport !== null) {
        this.step = id;
      }
    },

    onChangeTabCheck(id) {
      this.tabCheck = id;
    },

    async onImport() {
      this.selectedItem = this.listSuccess.map(e => {
        return {
          ...e,
          quantity: e.system_qty,
          check_qty: e.real_qty,
          unit: {
            id: e.unit_uid,
            unit_id: e.unit_id,
            unit_name: e.unit_name,
          }
        }
      });
      this.handleCloseImport()
    },

    onExportTemplate() {
      let workbook = new Workbook();
      let header = [
        {header: 'Mã hàng hóa (SKU) (*)', key: 'sku'},
        {header: 'Tên hàng hoá', key: 'item_name'},
        {header: 'Mã đơn vị tính (*)', key: 'unit_id'},
        {header: 'Số lượng (*)', key: 'quantity'},
      ]

      // TAB Dữ liệu import ===================
      const worksheet = workbook.addWorksheet('Dữ liệu dùng để import');
      worksheet.properties.defaultColWidth = 22;
      worksheet.columns = header;
      // Add row using key mapping to columns
      let itemOfBrand = this.listProduct.map(e => {
        return {
          sku: e.sku,
          item_name: e.item_name,
          unit_id: e.unit_id,
          price: e.price,
        };
      });

      itemOfBrand.forEach(d => {
        worksheet.addRow(d);
      });
      worksheet.eachRow({includeEmpty: true}, (row, rowNumber) => {
        row.eachCell((cell) => {
          if (rowNumber === 1) {
            row.font = {bold: true};
            cell.alignment = {
              vertical: 'middle', horizontal: 'center'
            };
            for (let i = 1; i <= 4; i++) {
              row.getCell(i).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'C7C7C7'}
              };
              row.getCell(i).border = {
                top: {style: 'thin'},
                left: {style: 'thin'},
                bottom: {style: 'thin'},
                right: {style: 'thin'}
              };
            }
          }
        });
      });

      // TAB Dữ liệu mẫu =============================
      const worksheetExample = workbook.addWorksheet('Dữ liệu mẫu');
      worksheetExample.properties.defaultColWidth = 22;
      // add column headers
      worksheetExample.columns = header;
      // Add row using key mapping to columns
      let data = [
        {
          sku: "SKU-123456",
          item_name: "Hàng hóa số 1",
          unit_id: "THUNG",
          quantity: 50,
        }
      ];
      data.forEach(d => {
        worksheetExample.addRow(d);
      });

      worksheetExample.eachRow({includeEmpty: true}, (row, rowNumber) => {
        row.eachCell((cell) => {
          if (rowNumber === 1) {
            row.font = {bold: true};
            cell.alignment = {
              vertical: 'middle', horizontal: 'center'
            };
            for (let i = 1; i <= 7; i++) {
              row.getCell(i).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'C7C7C7'}
              };
              row.getCell(i).border = {
                top: {style: 'thin'},
                left: {style: 'thin'},
                bottom: {style: 'thin'},
                right: {style: 'thin'}
              };
            }
          }
        });
      });

      // Generate Excel File with given name
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        fs.saveAs(blob, `IMPORT_BALANCE_FORMAT_${this.formData.brand.trademark_id}.xlsx`);
      });
    },

    async onCheckFile() {
      if (this.fileImport) {
        this.isLoadingCheck = true;
        let formData = new FormData();
        formData.append("file", this.fileImport);
        const response = await base.preImport(formData, {
          data_type: 'STOCK_TAKE',
          trademark_uid: this.formData.brand.id,
          warehouse_uid: this.me.warehouse_uid,
          to_date: this.formData.stTime.getTime(),
        });
        if (response.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: response.data.error.message,
          });
        } else {
          this.listError = response.data.data.error_list;
          this.listSuccess = response.data.data.success_list
          if (this.listError.length > 0) {
            this.tabCheck = 1;
          } else {
            this.tabCheck = 2;
          }
          this.step = 2;
        }
        this.isLoadingCheck = false;
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Bạn phải chọn file dữ liệu import",
        });
      }
    },

    async onCreate() {
      if (this.selectedItem.length > 0 && this.formData.brand && this.formData.brand.id) {
        const details = this.selectedItem.map(e => {
          return {
            sku: e.sku,
            unit_id: e.unit_id,
            item_uid: e.item_uid,
            unit_uid: e.unit_uid,
            system_qty: e.quantity,
            real_qty: e.check_qty,
            gap_qty: e.check_qty - e.quantity,
            trademark_uid: e.trademark_uid,
            action: this.renderAction(e),
            note: e.note,
          };
        });
        const body = {
          "st_time": this.formData.stTime !== "" ? this.formData.stTime.getTime() : '',
          "status": "COMPLETED",
          "note": this.formData.note,
          "warehouse_uid": this.me.warehouse_uid,
          "trademark_uid": this.formData.brand.id,
          "details": details
        }
        this.isBtnLoading = true;
        const res = await inventoryService.createStockTake(body);
        if (res.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Tạo phiếu kiểm kê lỗi",
            text: res.data.error.message,
          });
        } else {
          this.$notify({
            group: "app",
            type: "success",
            title: "Tạo phiếu kiểm kê thành công",
          });
          this.resetForm();
          this.getInitData()
        }
        this.isBtnLoading = false;
      } else {
        let message = 'Vui lòng nhập chọn hàng hoá và điền thông tin kiểm kho'
        if(!this.formData.brand || !this.formData.brand.id) {
          message = 'Vui lòng chọn thương hiệu'
        }else if(!this.selectedItem.length){
          message = 'Vui lòng thêm hàng hoá vào danh sách kiểm kho'
        }
        this.$notify({
          group: "app",
          type: "error",
          title: "Nhập đầy đủ thông tin",
          text: message,
        });
      }
    },

    resetForm() {
      this.formData = {
        stTime: "",
        note: "",
      }
      this.selectedItem = [];
      this.isBtnLoading = false;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row" style="margin-left: -5px; margin-right: -5px;">
      <div class="col-lg-12 col-md-12">
        <div class="alert alert-info mb-2">
          Lưu ý: Trong quá trình kiểm kho nên dừng mọi hoạt động bán hàng để đảm bảo sự chính xác của số liệu hàng hoá
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
        <div class="bg-white box-shadow" style="border: 1px solid #eff2f7;">
          <TableLoading v-if="isBusy"/>
          <template v-else>
            <div class="bg-white p-3">
              <div class="input-no-br d-flex">
                <div class="d-flex w-50">
                  <b-input-group prepend="Nơi kiểm hàng" class="w150">
                    <b-input
                        type="text"
                        :disabled="true"
                        :value="me.warehouse.warehouse_name"></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex w-50">
                  <div class="custom-input-group" style="min-width: 150px">Thời gian kiểm hàng</div>
                  <date-picker
                      type="date"
                      id="requireTime"
                      v-model="formData.stTime"
                      :first-day-of-week="1"
                      lang="vi"
                      format="DD/MM/YYYY"
                      placeholder="Chọn thời gian"
                      class="custom-datepicker"
                      :disabled-date="(e)=>m_func__disabledDatePicker(e,'future')"
                      :clearable="false"
                      @change="(e)=>onChangeBrandAndTime('time', e)"
                  ></date-picker>
                </div>
              </div>
              <div class="input-no-br d-flex">
                <div class="d-flex w-100 mtn1">
                  <div class="custom-input-group" style="min-width: 150px">Nhãn hàng<span class="text-danger ml-1">(*)</span></div>
                  <multiselect
                      class="custom-multi-select"
                      id="brand"
                      v-model="formData.brand"
                      :options="listBrand"
                      track-by="id"
                      label="trademark_name"
                      placeholder="Chọn nhãn hàng"
                      noOptions="Danh sách trống"
                      :show-labels="false"
                      @select="(e)=>onChangeBrandAndTime('brand', e)"
                  ></multiselect>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 mb-2 custom">
        <div class="mb-2 bg-white box-shadow">
          <TableLoading v-if="isBusy || isChangeBrandTime"/>
          <div v-else>
            <div class="search-item p-3 custom-border position-relative">
              <div class="custom-search-with-result">
                <div class="d-flex align-items-center">
                  <b-input type="text" id="search" placeholder="Tìm kiếm hàng hoá"
                           v-model="keyword"
                           @input="onSearchItem($event)"></b-input>
                  <span class="mx-3 text-muted">hoặc</span>
                  <button
                      class="min-w-140 btn btn-outline-primary"
                      type="submit"
                      @click="handleImport()">
                    Import hàng hoá
                  </button>
                </div>
                <i class="bx bx-search"></i>
                <div class="search-result" v-if="listResult.length > 0">
                  <div
                      v-for="(item, index) in listResult"
                      @click="onSelectResult(item)"
                      :key="index"
                      class="px-3 py-2 item-search-result">
                    <p class="mb-1 font-weight-medium">{{ item.sku }} - {{ item.item_name }}</p>
                    <p class="mb-0 font-italic">Tồn kho {{ item.quantity }}</p>
                  </div>
                </div>
              </div>
            </div>
            <table class="table table-bordered scroll-table">
              <thead>
              <tr>
                <th scope="col">Mã</th>
                <th scope="col">Hàng hoá {{ selectedItem.length > 0 ? `(${selectedItem.length})` : '' }}</th>
                <th scope="col">ĐVT</th>
                <th scope="col">Tồn kho</th>
                <th scope="col">Thực tế</th>
                <th scope="col">Chênh lệch</th>
                <th scope="col">Ghi chú</th>
                <th scope="col">Xử lý</th>
                <th scope="col">
                  <i @click="removeItem()" class="bx bx-revision font-size-16 text-danger ipos-pointer"></i>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in selectedItem" :key="item.id">
                <td>{{ item.sku }}</td>
                <td>{{ item.item_name }}</td>
                <td style="width: 220px">
                  <multiselect
                      id="unit"
                      :value="item.unit"
                      :options="listUnit"
                      track-by="id"
                      label="unit_name"
                      placeholder="Chọn đơn vị tính"
                      noOptions="Danh sách trống"
                      @open="onShowUnit(item)"
                      :show-labels="false"
                      :loading="loadUnit"
                      class="max-w200"
                      @select="(e)=>handleChangeUnit(e,item)"
                      open-direction="bottom"
                  ></multiselect>
                </td>
                <td>{{ formatPrice(item.quantity) }}</td>
                <td>
                  <b-input-group class="sm-group">
                    <component-currency-input
                        class="text-center"
                        type="text" v-model="item.check_qty" style="width: 100%"></component-currency-input>
                  </b-input-group>
                </td>
                <td>{{ formatPrice(item.check_qty - item.quantity) }}</td>
                <td>
                  <b-input-group class="sm-group">
                    <b-input
                        class="text-left"
                        @input="onChangeNote($event, item.id)"
                        type="text" :value="item.note"></b-input>
                  </b-input-group>
                </td>
                <td>{{ renderAction(item) }}</td>
                <td>
                  <i @click="removeItem(item.id)" class="bx bx-x-circle font-size-16 text-danger ipos-pointer"></i>
                </td>
              </tr>
              <tr v-if="selectedItem.length === 0">
                <td colspan="9">
                  <p class="p-3 m-0 text-center">Chưa chọn hàng hoá</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="table-responsive mb-0 bg-white box-shadow ">
          <TableLoading v-if="isBusy"/>
          <div v-else class="p-3" style="border: 1px solid #eff2f7;">
            <div class="d-flex align-content-center justify-content-between">
              <b-input class="mb-3" type="text" id="note" v-model="formData.note"
                       placeholder="Ghi chú (nếu có)"></b-input>
            </div>
            <div class="d-flex align-content-center justify-content-end">
              <button
                  class="btn btn-primary w-md d-block"
                  type="submit"
                  @click="onCreate()"
                  v-bind:disabled="isBtnLoading">
                <template v-if="isBtnLoading">
                  <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                  Đang xử lý...
                </template>
                <template v-else>Tạo mới</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Import -->
    <b-modal
        id="md-import"
        title="Import hàng hoá kiểm kê"
        size="lg"
        centered
        hide-footer
    >
      <form>
        <div class="row mb-3">
          <div class="col-lg-3">
            <a
                @click="onChangeTab(1)"
                class="btn rounded-pill mb-2"
                :class="{ 'btn-secondary': step === 1, 'btn-light': step === 2 }">
              Bước 1: Chọn file
            </a>
            <a
                @click="onChangeTab(2)" class="btn rounded-pill"
                :class="{ 'btn-secondary': step === 2, 'btn-light': step === 1 }">
              Bước 2: Kiểm tra dữ liệu
            </a>
          </div>
          <div class="col-lg-9">
            <div class="row" v-if="step === 1">
              <div class="col-lg-12">
                <p class="mt-2">Tải tệp excel mẫu của nhãn <a href="javascript:void(0)" @click="onExportTemplate">tại
                  đây</a></p>
              </div>
              <div class="col-lg-12">
                <p class="mb-2">Chọn file dữ liệu chuẩn bị import vào phần mềm</p>
                <b-form-file
                    v-model="fileImport"
                    :state="Boolean(fileImport)"
                    placeholder="Chọn file hoặc kéo file vào đây..."
                    drop-placeholder="Kéo file vào đây..."
                ></b-form-file>
              </div>
            </div>
            <div class="row" v-if="step === 2">
              <div class="col-lg-12" v-if="listError.length > 0">
                <div class="alert alert-danger">
                  Vui lòng kiểm tra và chỉnh sửa lại file import, có lỗi ở các dòng dưới đây
                </div>
              </div>
              <div class="col-lg-12">
                <a
                    @click="onChangeTabCheck(1)"
                    class="btn btn-sm rounded-pill mr-2 mb-3"
                    :class="{ 'btn-danger': tabCheck === 1, 'btn-outline-secondary': tabCheck === 2 }">
                  Lỗi ({{ listError.length }})
                </a>
                <a
                    @click="onChangeTabCheck(2)" class="btn btn-sm rounded-pill mb-3"
                    :class="{ 'btn-success': tabCheck === 2, 'btn-outline-secondary': tabCheck === 1 }">
                  Hợp lệ ({{ listSuccess.length }})
                </a>
              </div>
              <div class="col-lg-12" v-if="tabCheck === 1 && listError.length > 0">
                <table class="table table-bordered">
                  <tr>
                    <th>Mã</th>
                    <th>Tên</th>
                    <th>Mã ĐVT</th>
                    <th>Số lượng</th>
                    <th>Lỗi</th>
                  </tr>
                  <tr v-for="(item, i) in listError" :key="i">
                    <td>{{ item.sku }}</td>
                    <td>{{ item.item_name }}</td>
                    <td>{{ item.unit_id }}</td>
                    <td>{{ item.real_qty ? item.real_qty : "" }}</td>
                    <td>
                      <span class="text-danger">{{ item.error_message }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-lg-12" v-if="tabCheck === 2 && listSuccess.length > 0">
                <table class="table table-bordered">
                  <tr>
                    <th>Mã</th>
                    <th>Tên</th>
                    <th>Mã ĐVT</th>
                    <th>Số lượng</th>
                  </tr>
                  <tr v-for="(item, i) in listSuccess" :key="i">
                    <td>{{ item.sku }}</td>
                    <td>{{ item.item_name }}</td>
                    <td>{{ item.unit_id }}</td>
                    <td>{{ item.real_qty }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
      <footer class="modal-footer px-0 pb-0">
        <button v-if="step === 1" type="button" class="btn btn-primary" @click="onCheckFile" :disabled="isLoadingCheck">
          <template v-if="isLoadingCheck">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Tiếp tục</template>
        </button>
        <button
            v-if="step === 2 && listSuccess.length > 0"
            type="button"
            class="btn btn-primary ml-2"
            @click="onImport"
            :disabled="isLoadingCheck"
        >
          <template v-if="isLoadingCheck">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Import</template>
        </button>
      </footer>
    </b-modal>
  </Layout>
</template>